import { useMutation } from '@tanstack/react-query';
import useWorkspaceSystem from '../systems/useWorkspaceSystem';

type UseDeleteWorkspaceLogoMutationParams = {
	workspaceID: number;
	onSuccess?: () => void;
	onError?: ( error: unknown ) => void;
};

const useDeleteWorkspaceLogoMutation = ( {
	workspaceID, onSuccess, onError
}: UseDeleteWorkspaceLogoMutationParams ) => {
	const system = useWorkspaceSystem();

	return useMutation(
		async () => system.deleteWorkspaceLogo( { workspaceID } ),
		{ onSuccess, onError }
	);
};

export default useDeleteWorkspaceLogoMutation;
